import { useQuery } from '@tanstack/react-query';

import { supabase } from '@/integrations/supabase/client';
import { getEnvironmentConfig } from '@/lib/environment';

export const useFeatureFlag = (flag: string) => {
  const { isProduction } = getEnvironmentConfig();
  const environment = isProduction ? 'production' : 'development';

  const { data: isFeatureEnabled } = useQuery({
    queryKey: ['feature-flag', flag, environment],
    initialData: false,
    queryFn: async () => {
      const { data: flagEnabled, error } = await supabase
        .from('feature_flags')
        .select('enabled')
        .eq('feature_key', flag)
        .eq('environment', environment)
        .maybeSingle();

      if (error) {
        console.warn('Error fetching feature flag:', error);
        return false;
      }

      return flagEnabled?.enabled ?? false;
    },
  });

  return {
    isFeatureEnabled,
  };
};
